import { useSearchParams } from "react-router-dom";
import IntakeForm from "../components/IntakeForm";
import { Reveal } from "../components/Reveal";

export default function Partner() {
  const [params] = useSearchParams();
  const initialType = params.get("type") || "partnership";
  return (
    <div className="pt-16 md:pt-20" data-testid="page-partner">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-6">Partner With Us</div>
        <h1 className="text-5xl sm:text-6xl lg:text-8xl font-extrabold text-navy tracking-tighter leading-[0.95] max-w-5xl">
          Every industry. Every kind of partnership.
        </h1>
        <p className="mt-8 text-lg md:text-xl text-slate max-w-2xl leading-relaxed">
          Stone Shire Group is open to business partnerships across any sector — not just the divisions we already operate. If the fit is right, we will build something new together.
        </p>
      </section>

      <section className="bg-stone">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-10">
          <Reveal className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-4">Start the conversation</div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy tracking-tight leading-tight">Tell us what you&apos;re looking for.</h2>
            <p className="mt-4 text-slate leading-relaxed">
              The form below adapts based on your intent — service request, partnership, subcontracting, project management, or general.
            </p>
            <div className="mt-8 text-sm text-navy">
              Prefer email? Reach us at{" "}
              <a href="mailto:info@stoneshire.ca" className="font-semibold underline decoration-forest underline-offset-4" data-testid="partner-email-link">info@stoneshire.ca</a>.
            </div>
          </Reveal>
          <div className="md:col-span-8 bg-white rounded-3xl border border-stone p-6 md:p-10">
            <IntakeForm initialType={initialType} />
          </div>
        </div>
      </section>
    </div>
  );
}
